import { request } from '@/shared/api/request'

export const save = (params) => {
	return request({ url: '/user/save', method: 'POST', params })
}
